import { gql } from "@apollo/client";

export const GET_PACIENTES_RI_EV = gql`
query getPacientesRIEV($filter: PacienteRIEVFilterInput!){
    pacientesRIEV (filter: $filter) {    
        success,
        error,
        valorEsperado {
            idPaciente,
            nombre
        }
    }
  }
`;